import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Nav() {
  const [alt, setAlt] = useState(false);
  const [fix, setFix] = useState(false);
  const [scrollPos, setScrollPos] = useState(12);
  const [showNavLinks, setNavLinks] = useState(true);
  const navigate = useNavigate();

  function handleNavVisibility() {
    setNavLinks((showNavLinks) => !showNavLinks);
  }
  function setFixed() {
    if (window.scrollY >= 240) setFix(true);
    else setFix(false);
    setNavLinks(true);
  }
  const { pathname } = useLocation();
  const altPaths = ["/blog", "/news"];

  const isOtherPages = altPaths.some((path) => pathname.includes(path));

  window.addEventListener("scroll", setFixed);
  function resetNav(directory) {
    if (!pathname.includes("blog") && !pathname.includes("news")) {
      document.getElementById(directory).scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        setNavLinks((showNavLinks) => !showNavLinks);
      }, 50);
    } else navigate(`/`);
  }

  useEffect(() => {
    const isAltRoute = altPaths.some((path) => pathname.includes(path));
    setAlt(isAltRoute);

    const handleScroll = () => {
      setFix(window.scrollY >= 60);
    };

    handleScroll();

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [pathname]);

  return (
    <nav className={`navbar ${fix ? "onscroll" : ""} ${alt ? "onscroll" : ""}`}>
      <div className="navbar-left">
        <a href="/">
          <img src={require("../img/mocean-logo-full-dark.png")} alt="" />
          <img src={require("../img/mocean-logo-full.png")} alt="" />
        </a>
      </div>
      <div className={`navbar-center ${showNavLinks ? "hidden" : ""}`}>
        <ul>
          <li>
            <a onClick={() => resetNav("hero")}>Home</a>
            {/* <Link to="/">Home</Link> */}
          </li>
          <li>
            <a onClick={() => resetNav("feature-summary")}>Products</a>
          </li>
          <li>
            <a onClick={() => resetNav("features")}>Features</a>
          </li>
          <li>
            <a onClick={() => resetNav("pricing")}>Pricing</a>
          </li>
          <li>
            <a onClick={() => resetNav("feature-api")}>Documentation</a>
          </li>
          <li className="nav-dropdown-container">
            <button>
              More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <mask
                  id="mask0_1282_433"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="12"
                  height="13"
                >
                  <rect
                    x="12"
                    y="0.000976562"
                    width="12"
                    height="12"
                    transform="rotate(90 12 0.000976562)"
                    fill="#D9D9D9"
                  />
                </mask>
                <g mask="url(#mask0_1282_433)">
                  <path
                    d="M1 4.01348L1.8875 3.12598L6 7.23848L10.1125 3.12598L11 4.01348L6 9.01348L1 4.01348Z"
                    fill="black"
                  />
                </g>
              </svg>
              <div className="nav-dropdown">
                <a href="/blog">Blog</a>
                <a href="/news">News</a>
                <a onClick={() => resetNav("contact-us")}>Contact Us</a>
              </div>
            </button>
          </li>
          <li>
            <a href="https://dashboard.moceanapi.com/login">Log in</a>
          </li>
          <li>
            <a href="/blog">Blog</a>
          </li>
          <li>
            <a href="/news">News</a>
          </li>
        </ul>
      </div>
      <div className="navbar-right">
        <a href="https://dashboard.moceanapi.com/login">
          <span>Log in</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#fff"
          >
            <path d="M478.09-135.87v-83h263.04v-522.26H478.09v-83h263.04q34.48 0 58.74 24.26 24.26 24.26 24.26 58.74v522.26q0 34.48-24.26 58.74-24.26 24.26-58.74 24.26H478.09Zm-79.42-164.65-58.89-58.41 79.57-79.57H135.87v-83h283.48l-79.57-79.57 58.89-58.41L577.91-480 398.67-300.52Z" />
          </svg>
        </a>
        <a href="https://dashboard.moceanapi.com/register">Sign up</a>
        <button onClick={handleNavVisibility}>
          <svg
            className="ham-icon"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M3 14.4883V12.7592H17.3388V14.4883H3ZM3 7.72917V6H17.3388V7.72917H3Z" />
          </svg>
        </button>
      </div>
    </nav>
  );
}

export default Nav;
